import { Box, CircularProgress, SxProps } from "@mui/material";
import { SystemStyleObject, Theme } from "@mui/system";
import { ReactNode } from "react";

const defaultSx: SxProps = {};
export const Fetching = ({
  fetching,
  disableFullWidth,
  enableFullHeight,
  children,
  sx = defaultSx,
  spinner = true,
}: {
  fetching: boolean;
  disableFullWidth?: boolean;
  enableFullHeight?: boolean;
  children?: ReactNode;
  sx?: SystemStyleObject<Theme>;
  spinner?: boolean;
}) => {
  return (
    <Box
      sx={[
        {
          position: spinner ? "relative" : undefined,
          opacity: fetching ? 0.5 : undefined,
          pointerEvents: fetching ? "none" : undefined,
          width: disableFullWidth ? undefined : "100%",
          height: enableFullHeight ? "100%" : undefined,
        },
        ...(sx ? [sx] : []),
      ]}
    >
      {children}
      {fetching && spinner ? (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
          }}
        >
          <CircularProgress />
        </Box>
      ) : null}
    </Box>
  );
};
